import ToastHelper from 'general/helpers/ToastHelper';
import agencyBankApi from 'api/agencyBankApi';

const agencyBankHelper = {
    // ---- methods ----
    callApiGetAgencyBankList: async (params) => {
        try {
            const res = await agencyBankApi.getAgencyBankList(params);
            const { result, bankAccounts } = res;
            if (result === 'success' && bankAccounts) {
                return bankAccounts;
            }
            return {};
        } catch (error) {
            ToastHelper.showError(error?.response?.data?.reason);
        }
    },

    callApiCreateAgencyBank: async (params) => {
        try {
            const res = await agencyBankApi.createAgencyBank(params);
            return res;
        } catch (error) {
            ToastHelper.showError(error?.response?.data?.reason);
        }
    },

    callApiUpdateAgencyBank: async (bankAccountId, params) => {
        try {
            const res = await agencyBankApi.updateAgencyBank(bankAccountId, params);
            const { result } = res;
            return result === 'success';
        } catch (error) {
            ToastHelper.showError(error?.response?.data?.reason);
        }
    },

    callApiDeleteAgencyBank: async (bankAccountId) => {
        try {
            const res = await agencyBankApi.deleteAgencyBank(bankAccountId);
            const { result } = res;
            return result === 'success';
        } catch (error) {
            ToastHelper.showError(error?.response?.data?.reason);
        }
    },
};

export default agencyBankHelper;
